import { Box, SxProps } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import Step from '@components/Stepper/Step';

const boxContainerSx: SxProps = {
    alignItems: 'flex-start',
    display: 'flex',
    justifyContent: 'space-between',
    mx: 'auto',
};

interface StepperProps extends PropsWithChildren {
    steps: {
        [key: string]: {
            active: boolean;
            label: string;
            number: number;
            sx?: SxProps;
        };
    };
    stepsContainerSx?: SxProps;
    sx?: SxProps;
}

const Stepper: FC<StepperProps> = ({ children, steps, stepsContainerSx, sx }) => (
    <Box
        data-test-id="stepper"
        maxWidth="md"
        sx={{
            ...boxContainerSx,
            ...sx,
        }}
    >
        {children}
        <Box data-test-id="steps-container" display="flex" sx={stepsContainerSx}>
            {Object.values(steps).map((step) => (
                <Step key={step.number} {...step} />
            ))}
        </Box>
    </Box>
);

export default Stepper;
